module.exports = __webpack_public_path__ + "img/clock-nine-thirty.94fd0343.svg";